"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../models");
var UrlSlugResolver = /** @class */ (function () {
    function UrlSlugResolver() {
    }
    UrlSlugResolver.prototype.resolveUrl = function (data) {
        if (!data.linkResolver) {
            if (data.enableAdvancedLogging) {
                console.warn("You have to implement 'linkResolver' in your Model class or your query in order to get url of this item. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
            }
            return undefined;
        }
        if (!data.item) {
            if (data.enableAdvancedLogging) {
                console.warn("Cannot resolve link for field '" + data.fieldName + "' because no item was provided to URL slug field (item may be missing from response). This warning can be turned off by disabling 'enableAdvancedLogging' option.");
            }
            return undefined;
        }
        var url = data.linkResolver(new models_1.Link({
            urlSlug: data.fieldValue,
            type: data.type,
            codename: data.item.system.codename,
            itemId: data.item.system.id,
        }), {
            linkText: undefined // link text is available only for links inside rich text field
        });
        if (!url) {
            if (data.enableAdvancedLogging) {
                console.warn("'linkResolver' is configured, but url resolved for '" + data.item.system.codename + "' item of '" + data.item.system.type + "' type inside '" + data.fieldName + "' field resolved to an undefined url. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
            }
            return undefined;
        }
        return url;
    };
    return UrlSlugResolver;
}());
exports.UrlSlugResolver = UrlSlugResolver;
exports.urlSlugResolver = new UrlSlugResolver();
//# sourceMappingURL=url-slug.resolver.js.map